function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatVSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.381,
    height: 23.247,
    viewBox: "0 0 24.381 23.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.855 28.191a1.958 1.958 0 0 0 1.343-.726l4.051-3.654h7.221c3.313.011 5.173-1.893 5.173-5.162v-8.542c0-3.269-1.86-5.162-5.173-5.162H9.435c-3.313 0-5.173 1.893-5.173 5.162v8.542c0 3.269 1.9 5.162 5.1 5.162H9.8V27a1.051 1.051 0 0 0 1.055 1.191zm4.381-8.391a1.276 1.276 0 0 1-1.068-.583l-2.7-3.28a1.219 1.219 0 0 1-.3-.781 1.012 1.012 0 0 1 1.013-1.024 1.047 1.047 0 0 1 .881.484l2.124 2.7 4.557-7.287a1.065 1.065 0 0 1 .892-.572.993.993 0 0 1 1.046.958 1.515 1.515 0 0 1-.286.782l-5.151 8.024a1.171 1.171 0 0 1-1.008.579z",
    transform: "translate(-4.262 -4.944)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatVSign);
export default __webpack_public_path__ + "static/media/chat-v-sign.2c4361cd.svg";
export { ForwardRef as ReactComponent };